/**
 * A HOC wrapping Material UIs TableRow Component. Used to unify the styles
 * across all of our tables. NOTE: TableRow and HeaderRow are both <TableRow>
 * components, but HeaderRow components belong inside a TableHead, while
 * TableRow belongs inside TableBody.
 */
import { isEmpty } from 'lodash';
import React from 'react';
import { withStyles } from 'tss-react/mui';
import { TableRow } from '@mui/material';

const styles = (theme) => {
  if (isEmpty(theme)) return {};

  return {
    root: {
      height: '48px',
      '&:nth-of-type(odd)': {
        backgroundColor: '#FFFFFF',
      },
    },
  };
};

export default withStyles((props) => {
  const { classes } = props;
  return <TableRow className={classes.root} {...props} />;
}, styles);
